import stbAPIGateway from '../../../../services/stbAPIGateway';

export const getCsvExternalIdpOidc = async ({ rootGetters }, { clientSid }) => {
  const axios = rootGetters['app/stbAxios'];

  const stbApi = stbAPIGateway(axios, process.env.API_URL);

  const result = await stbApi.getHubCsvExternalIdpOidc(clientSid);
  return result;
};
